import { createStore, compose } from 'redux';
import {rootReducer} from './rootReducer';
import createMiddleware, { sagaMiddleware } from './middleware'
import sharedSagas from './Shared/sagas';
import customerPortalSagas from './CustomerPortal/sagas';
import curatedVehicleSagas from "./CuratedVehicles/sagas";

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(createMiddleware()));
sagaMiddleware.run(sharedSagas);
sagaMiddleware.run(customerPortalSagas);
sagaMiddleware.run(curatedVehicleSagas);
export default store;
